import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectForumsQueryItems } from '../../../../../../redux/forums/selector';
import { forums } from '../../../../../../redux/forums/action';
import ForumComponent from '../components/forum.component';
import { selectForumGroupsListItems } from '../../../../../../redux/forum-groups/selector';
import { forumGroups } from '../../../../../../redux/forum-groups/action';

const ManagementForum = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const ForumQueryItems = useSelector(selectForumsQueryItems)
    const forumGroupsItems = useSelector(selectForumGroupsListItems)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [mediaFiles, setMediaFiles] = useState<any>([])

    const [
        selectedForum,
        setSelectedForum
    ] = useState<any>({

    })

    useEffect(
        () => {
            dispatch(forumGroups.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-groups/list`, entity: 'forumGroup', jsonData: {

                }
            }))
            if (parmas?.id > 0) {
                fetchForumById()
                setIsLoading(false)
            }
        },
        []
    )
    const fetchForumById = () => {
        dispatch(forums.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forums/query`,
            entity: 'forums',
            jsonData: {
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleBasicFormChange: any = (event: any, field: string) => {
        setSelectedForum({ ...selectedForum, [field]: event });
    }
    const handleFormMediaItemChange: any = ({ value }: any) => {
        setMediaFiles(value);
    }
    useEffect(
        () => {

            if (parmas?.id > 0) {
                fetchForumById()
                setIsLoading(false)
            } else {
                setIsLoading(false)
            }
        },
        []
    )
    useEffect(
        () => {
            if (isQuery) {
                setSelectedForum(ForumQueryItems?.result?.items)
            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        mediaFiles.splice(
            mediaFiles.length - 1,
            1
        )

        const forumData = {

            "Context": {

            },
            "Id": selectedForum?.Id || 0,
            "Name": selectedForum?.Name,
            "Description": selectedForum?.Description,
            "DisplayOrder": selectedForum?.DisplayOrder,
            "CommunityId": selectedForum?.CommunityId,
            "MediaMappings": {
                "MediaFiles": mediaFiles,
                "Templates": []

            }
        }
        if (parmas?.id > 0) {
            await dispatch(forums.resetAction({ actionType: 'update' }))
            await dispatch(forums.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forums`,
                entity: 'forums',
                jsonData: {
                    Records: [
                        forumData
                    ]
                }
            })).then(() => {
                back()
            })

        } else {
            await dispatch(forums.resetAction({ actionType: 'create' }))
            await dispatch(forums.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forums`, entity: 'forums', jsonData: {

                    Records: [
                        forumData
                    ]
                }
            })).then(() => {
                back()
            })
        }

    }

    const back = () => {
        navigate('/management/e-applications/forum/forums')
    }

    return (
        <>

            {isLoading ? <PageLoader /> :
                <ForumComponent
                    handleBasicFormChange={handleBasicFormChange}
                    selectedForum={selectedForum}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    forumGroups={forumGroupsItems?.result?.items}
                    onFormItemChange={handleFormMediaItemChange}
                    id={parmas?.id}
                />
            }

        </>
    )
}

export default ManagementForum;